"use client";
import { clickEvent } from "@/lib/atInternetTags";
import clsx from "clsx";
import { usePathname, useRouter } from "next/navigation";
import { type ReactNode, useState } from "react";
import { BasketIcon, SearchIcon, UserIcon } from "ui/iconsN";
import { menuStore } from "./MenuInner";
import { MenuLink } from "./MenuLink";
import { PhoneHeader } from "./PhoneHeader";
import { isSearchBarVisibleStore } from "./store";

type Props = {
  basket: ReactNode;
  isHeaderTransparent: boolean;
};
export const Side = ({ basket, isHeaderTransparent }: Props) => {
  const router = useRouter();
  const pathname = usePathname();
  const [isBasketOpen, setIsBasketOpen] = useState(false);

  return (
    <div className="hidden xl:flex items-center gap-1.5">
      {pathname.startsWith("/voyage/") && (
        <>
          <div
            className={clsx("cursor-pointer p-1.5 rounded-sm transition-colors hover:bg-bg-2/20", {
              "stroke-tx-1 hover:bg-bg-2/20": !isHeaderTransparent,
              "stroke-white hover:bg-white/20": isHeaderTransparent,
            })}
            onClick={() => {
              isSearchBarVisibleStore.set(!isSearchBarVisibleStore.get());
              menuStore.set(null);
            }}
          >
            <SearchIcon />
          </div>
          <div className="h-8 w-px bg-bg-2/20 z-10" />
        </>
      )}
      <MenuLink
        isHeaderTransparent={isHeaderTransparent}
        href="/account/"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          clickEvent({
            event: "click.navigation",
            click: "mon_compte",
            click_chapter1: "menu",
          });
          router.push("/account/");
        }}
      >
        <UserIcon />
        Mon compte
      </MenuLink>
      <div className="h-8 w-px bg-bg-2/20 z-10" />
      <div className="group relative select-none p-1.5 cursor-pointer">
        <BasketIcon
          className={clsx({
            "text-tx-1": !isHeaderTransparent,
            "text-white": isHeaderTransparent,
          })}
          onClick={() => setIsBasketOpen(!isBasketOpen)}
        />
        <div
          className={clsx(
            "bg-primary rounded-lg text-white group-hover:block left-1/2 p-2 absolute top-[calc(100%+4px)] -translate-x-1/2 z-50 w-80 cursor-default",
            "after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-full after:border-8 after:border-transparent after:border-b-primary",
            {
              block: isBasketOpen,
              hidden: !isBasketOpen,
            },
          )}
        >
          {basket}
        </div>
      </div>
      <div className="h-8 w-px bg-bg-2/20 z-10" />
      <PhoneHeader className="ml-1.5" isHeaderTransparent={isHeaderTransparent} onClick={() => menuStore.set(null)} />
    </div>
  );
};
